import type {
  GenerateAndScheduleResponse,
  SkippedKeywordInfo,
} from '@/services/blogCreationService';

export function duplicateSkips(result: GenerateAndScheduleResponse | null): SkippedKeywordInfo[] {
  return (result?.skipped ?? []).filter(skip => skip.reason === 'duplicate_in_progress');
}

export function hasDuplicateSkips(result: GenerateAndScheduleResponse | null): boolean {
  return duplicateSkips(result).length > 0;
}

export function duplicateSkipContentIds(result: GenerateAndScheduleResponse | null): string[] {
  return duplicateSkips(result)
    .map(item => item.content_id)
    .filter((id): id is string => Boolean(id));
}
